import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./WixPriceUIHelper";
const WixPriceUIContext = createContext();

export function useWixPriceUIContext() {
  return useContext(WixPriceUIContext);
}

export const WixPriceUIConsumer = WixPriceUIContext.Consumer;

export function WixPriceUIProvider({ priceUIEvents, children }) {
  // initial filter
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  // Query Params set when do pagination ,filter,search
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const [ids, setIds] = useState([]);

  const value = {
    ids,
    setIds,
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    newPriceButtonClick: priceUIEvents.newPriceButtonClick,
    openEditPricePage: priceUIEvents.openEditPricePage,
    openDeletePriceDialog: priceUIEvents.openDeletePriceDialog,
  };
  return (
    <WixPriceUIContext.Provider value={value}>{children}</WixPriceUIContext.Provider>
  );
}
